"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmountFromStringInput = exports.parseAmountWithCommaOrThousands = void 0;
const parseAmountWithCommaOrThousands = (sanitizedAmount) => {
    if (sanitizedAmount.includes(".")) {
        return parseFloat(sanitizedAmount.replace(/,/g, ""));
    }
    const lastCommaIndex = sanitizedAmount.lastIndexOf(",");
    if (lastCommaIndex !== -1) {
        const partAfterComma = sanitizedAmount.slice(lastCommaIndex + 1);
        const commaCount = (sanitizedAmount.match(/,/g) ?? []).length;
        if (commaCount === 1 && /^\d{1,2}$/.test(partAfterComma)) {
            return parseFloat(sanitizedAmount.replace(",", "."));
        }
    }
    return parseFloat(sanitizedAmount.replace(/,/g, ""));
};
exports.parseAmountWithCommaOrThousands = parseAmountWithCommaOrThousands;
const getAmountFromStringInput = (amount) => {
    const sanitizedAmount = amount.replace(/[^0-9,.]/g, "").trim();
    return (0, exports.parseAmountWithCommaOrThousands)(sanitizedAmount);
};
exports.getAmountFromStringInput = getAmountFromStringInput;
